export const HISTORICAL_REPORTING_METADATA_DELIMITER = '>';